import { render, staticRenderFns } from "./regRecordInfo.vue?vue&type=template&id=90e37ffe&scoped=true"
import script from "./regRecordInfo.vue?vue&type=script&lang=js"
export * from "./regRecordInfo.vue?vue&type=script&lang=js"
import style0 from "./regRecordInfo.vue?vue&type=style&index=0&id=90e37ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e37ffe",
  null
  
)

export default component.exports